export function stringToNumber(value?: string): number | undefined {
  if (!value) return undefined
  return Number(value.replace(/,/g, ''))
}
